import type { AxiosError } from 'axios';

type _ApiErrorDetails = {
  message: string;
  method: string;
  name: string;
  requestId: string;
  statusCode: number;
  url: string;
};

const extractErrorDetails = (err: AxiosError): _ApiErrorDetails => {
  const statusCode = err.response?.status ?? 0;
  const name = err.response?.statusText ?? 'Unknown Error';
  const requestId =
    (err.response?.headers?.['x-request-id'] as string) || (err.config?.headers?.['X-Request-ID'] as string) || '';
  const message = (err.response?.data as { message?: string })?.message ?? err.message ?? '';
  const method = (err.config?.method ?? '').toUpperCase();
  const url = err.config?.url ?? '';

  return { statusCode, name, requestId, message, method, url };
};

export default extractErrorDetails;
